import { render, staticRenderFns } from "./UserInfoDialog.vue?vue&type=template&id=49c5556d&scoped=true&"
import script from "./UserInfoDialog.vue?vue&type=script&lang=js&"
export * from "./UserInfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./UserInfoDialog.vue?vue&type=style&index=0&id=49c5556d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c5556d",
  null
  
)

export default component.exports